import styled from 'styled-components';

const Wrapper = styled.div`
    width: 100%;
    position: relative;
    flex-direction: column;
`;

const Track = styled.div`
    position: relative;
    width: 100%;
    display: block;
    overflow: ${p => p.showTransparent ? 'visible' : 'hidden'};
    white-space: nowrap;
    padding-bottom: 64px;
    z-index: 2;
    @media(max-width: ${({ visibleCardWidth }) => visibleCardWidth ? visibleCardWidth + 'px' : '0'}) {
        overflow: visible;
    }
    ${p => p.customStyles ? p.customStyles : ''}
`;

const SlideList = styled.div`
    display: ${props => props.isSlider || props.vertical ? 'block' : 'flex'};
    justify-content: ${props => props.align};
    cursor: grab;
    height: 100%;
    touch-action: pan-y;
`;

const Slide = styled.div`
    display: ${({ vertical }) => vertical ? 'block' : 'inline-block'};
    ${({ vertical }) => vertical ? 'height' : 'width'}: ${props => props.scale}%;
    outline: none;
    opacity: ${p => p.isTransparent ? '0.2' : '1'};
    ${p => p.customStyles ? p.customStyles : ''}
`;

export { Slide, SlideList, Track, Wrapper };
